// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1kX4V","label":"CategoryService_label__3WEgR","location":"CategoryService_location__203Cd"};